import { render, staticRenderFns } from "./FamilyMembersList.vue?vue&type=template&id=4b714572&scoped=true&"
import script from "./FamilyMembersList.vue?vue&type=script&lang=js&"
export * from "./FamilyMembersList.vue?vue&type=script&lang=js&"
import style0 from "./FamilyMembersList.vue?vue&type=style&index=0&id=4b714572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b714572",
  null
  
)

export default component.exports